import firebase from 'firebase';
//import * as axios from 'axios';

const firebaseConfig = {
    apiKey: "AIzaSyBuRqPn_29MkDckg8X6ipc6iuhIDSFxwCc",
    authDomain: "bsda-87db2.firebaseapp.com",
    databaseURL: "https://bsda-87db2.firebaseio.com",
    projectId: "bsda-87db2",
    storageBucket: "bsda-87db2.appspot.com",
    messagingSenderId: "737172343836",
    appId: "1:737172343836:web:9abbd506c5763b9408a3d9"
};
// Initialize Firebase
const fireApp = firebase.initializeApp(firebaseConfig);

// Auth
export function signIn(email, password) {
    return fireApp.auth().signInWithEmailAndPassword(email, password);
}

export function auth() {
    return fireApp.auth();
}

export function signOut() {
    return fireApp.auth().signOut();
}

// DB
export function getAnnouncements() {
    return fireApp.database().ref('announcements').once('value');
}
export function getProgramme() {
    return fireApp.database().ref('programmeUpdate').once('value');
}
export function setProgramme(obj) {
    return fireApp.database().ref('/programmeUpdate').set(obj);
}
export function setAnnouncements(obj) {
    return fireApp.database().ref('announcements').set(obj);
}


// Storage
export function storeFile(file) {
    return firebase.storage().ref().child(`prog-${new Date().getTime()}`).put(file);
}

// notification
